import React from 'react';
import { CokitchenProvider } from 'contexts/cokitchen.context';
import CokitchenContent from './content';

const CokitchenLayout = () => {
  return (
    <CokitchenProvider>
      <CokitchenContent />
    </CokitchenProvider>
  );
};

export default CokitchenLayout;
